import { Dictionary } from '../types/interfaces/dictionary';

export const buildOrdering = (ordering: Dictionary<string>) => {
    let result = 'ordering=';

    for (const [key, value] of Object.entries(ordering)) {
        result += `${value}${key},`;
    }

    return result
}